
import { Assessment } from '@/types/assessment';
import { AssessmentCard } from './AssessmentCard';

interface AssessmentsGridProps {
  assessments: Assessment[];
  onArchive: (id: string) => Promise<void>;
  onUnarchive: (id: string) => Promise<void>;
}

export function AssessmentsGrid({ assessments, onArchive, onUnarchive }: AssessmentsGridProps) {
  return (
    <div className="grid gap-4 sm:gap-5 lg:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4" onClick={(e) => e.stopPropagation()}>
      {assessments.map((assessment) => (
        <AssessmentCard 
          key={assessment.id} 
          assessment={assessment} 
          onArchive={onArchive}
          onUnarchive={onUnarchive}
        />
      ))}
    </div>
  );
}
